import { useRef } from "react";
import { BORDER_COLOR } from "../../theme";
import { Box, CircularProgress } from "@mui/material";
import { ScrollContainer, exploreTracksStyles } from "./styles";
import { ExploreTrackCard } from "./ExploreTrackCard";
import { ExploreTracksProps } from "./types";

export const ExploreTracks: React.FC<ExploreTracksProps> = ({
  setTrackToPlay,
  featuredTracks,
  publicTracks,
  loading,
  isFeaturedTracksLoaded,
  scrollContainerRef,
  genres,
  trackToPlay,
  setIsPlayButtonClicked,
  session,
  setInbox,
}) => {
  const loadingRef = useRef<HTMLDivElement | null>(null);

  return (
    <>
      <ScrollContainer ref={scrollContainerRef}>
        {genres.length === 0 && (
          <ExploreTrackCard
            tracks={featuredTracks}
            title="Tracks from featured artists"
            setTrackToPlay={setTrackToPlay}
            trackToPlay={trackToPlay}
            setIsPlayButtonClicked={setIsPlayButtonClicked}
            session={session}
            setInbox={setInbox}
            loading={loading}
          />
        )}
        <hr style={{ color: BORDER_COLOR }} />
        {isFeaturedTracksLoaded && (
          <ExploreTrackCard
            tracks={publicTracks}
            title="Published Tracks"
            setTrackToPlay={setTrackToPlay}
            trackToPlay={trackToPlay}
            setIsPlayButtonClicked={setIsPlayButtonClicked}
            session={session}
            setInbox={setInbox}
            loading={loading}
          />
        )}
        {loading && (
          <Box ref={loadingRef} sx={exploreTracksStyles.loadingContainer}>
            <CircularProgress />
          </Box>
        )}
      </ScrollContainer>
    </>
  );
};
